// extracted by mini-css-extract-plugin
export default {"productGallery":"eM-z","inQuickShop":"fM-z"};